import React from "react";
import { IconHeader } from "../../../components";
import { useTranslate } from "../../../features/translation/hooks/use-translation";
import { FormCheckboxGroup } from "../../../features/auto-form";

const TermsAndConditions = () => {
    const { t } = useTranslate();

    return (
        <div className="container request-section">
            <div className="row">
                <div className="col col-12">
                    <IconHeader title={t("form.termsAndConditions.title")} icon="document"/>
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-9">
                    <div className="text base"  dangerouslySetInnerHTML={{ __html: t("form.termsAndConditions.description") }} />
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-6" style={{ padding: "var(--space-4)", border:"1px solid var(--color-achromatic-base-400)", borderRadius:"4px" }}>
                    <FormCheckboxGroup 
                        name="request.termsAndConditions"
                        languagesection="form.termsAndConditions"
                        options={[
                            {label:"I have read and agree to the terms and conditions", value:"true"} // options are translated by translation hook
                        ]}
                        required   
                    />
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions;